"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packPosition = packPosition;
exports.unpackX = unpackX;
exports.unpackY = unpackY;
exports.unpackPosition = unpackPosition;
exports.getDelta = getDelta;
const X_BITS = 4;
const Y_MASK = (1 << X_BITS) - 1;
function packPosition(x, y) {
    return ((x << X_BITS) | (y & Y_MASK));
}
function unpackX(position) {
    return (position >> X_BITS) & Y_MASK;
}
function unpackY(position) {
    return position & Y_MASK;
}
function unpackPosition(position) {
    return [unpackX(position), unpackY(position)];
}
function getDelta(a, b) {
    const [ax, ay] = unpackPosition(a);
    const [bx, by] = unpackPosition(b);
    return {
        x: Math.abs(ax - bx),
        y: Math.abs(ay - by),
    };
}
